import { Box } from '@wix/design-system';
import { DomainSearchSuiteModule } from '@wix/domains-search-suite';
import clsx from 'clsx';
import React, { useRef } from 'react';
import { FAQs } from '../../Components/FAQs';
import { GateTldChips } from '../../Components/GateTldChips';
import { SiteGateHeader } from '../../Components/Headers';
import { MoreTools } from '../../Components/MoreTools';
import { TldPromotionBoxes } from '../../Components/TldPromotionBoxes';
import { VoucherBanner } from '../../Components/VoucherBanner';
import { useDomainSearchGateBi } from '../../hooks/useDomainSearchGateBi';
import { useGateScrollBi } from '../../hooks/useGateScrollBi';
import { useQuerySubmit } from '../../hooks/useQuerySubmit';
import { useSuggestedTldPrices } from '../../hooks/useSuggestedTldPrices';
import { prefetchRecommendations } from '../../hooks/useRecommendations';
import { useViewTransition } from '../../hooks/useViewTransition';
import { DomainSearchGateModule } from '../../module/domainSearchGate.module';
import { ViewMode } from '../../types';
import transition from '../viewTransitions.css';
import { HeroSearchBar } from './HeroSearchBar';
import s from './siteLevelGateHomeOptimized.scss';
import { useGateRevamp } from '../../hooks/useGateRevamp';
import { useGatePageBackground } from '../../hooks/useGatePageBackground';
import { PreSuggestions } from '../../Components/PreSuggestions';
import { PreSuggestionsOptimized } from '../../Components/PreSuggestionsOptimized';
import { SocialProofCard } from '../../Components/SocialProofCard';
import { REVAMP_VOUCHER_BANNER_CONFIG } from './revampVoucherBannerConfig';
export const SiteLevelGateHomeOptimizedContent = function (_temp) {
  let _ref = _temp === void 0 ? {} : _temp,
    _ref$viewMode = _ref.viewMode,
    viewMode = _ref$viewMode === void 0 ? ViewMode.GATE : _ref$viewMode,
    titleKey = _ref.titleKey;
  DomainSearchGateModule.SDK.hooks.useDomainsSearchGateBM();
  useSuggestedTldPrices();
  const _useViewTransition = useViewTransition(),
    navigateTo = _useViewTransition.navigateTo;
  const _DomainSearchSuiteMod = DomainSearchSuiteModule.SDK.hooks.useUrlRecovery(),
    getUrlState = _DomainSearchSuiteMod.getUrlState;
  const pageBackground = useGatePageBackground();
  const _useGateRevamp = useGateRevamp(),
    isRevampedGate = _useGateRevamp.isRevampedGate,
    iconOnlySearchButton = _useGateRevamp.iconOnlySearchButton,
    suggestionCardShadow = _useGateRevamp.suggestionCardShadow,
    preSuggestionsHidden = _useGateRevamp.preSuggestionsHidden;
  const showTldChips = isRevampedGate && preSuggestionsHidden;
  const pageRef = useRef(null);
  const searchbarRef = useRef(null);
  const tldGridRef = useRef(null);
  const faqRef = useRef(null);
  useDomainSearchGateBi({
    viewMode,
    pageType: 'landing'
  });
  useGateScrollBi({
    containerRef: pageRef,
    sections: [{
      section: 'searchbar',
      ref: searchbarRef
    }, {
      section: 'tld_grid',
      ref: tldGridRef
    }, {
      section: 'faq',
      ref: faqRef
    }]
  });
  useQuerySubmit({});
  return /*#__PURE__*/React.createElement(Box, {
    ref: pageRef,
    direction: "vertical",
    align: "center",
    width: "100%",
    height: "100%",
    overflow: "auto",
    backgroundColor: pageBackground,
    scrollBehavior: "smooth",
    boxSizing: "border-box",
    padding: "24px 40px"
  }, /*#__PURE__*/React.createElement("section", {
    className: clsx(s.firstFold, {
      [s.firstFoldAutoHeight]: isRevampedGate
    }),
    ref: searchbarRef
  }, /*#__PURE__*/React.createElement("div", {
    className: s.voucherBanner
  }, /*#__PURE__*/React.createElement(VoucherBanner, {
    optimizedVoucherCopy: true,
    configOverrides: isRevampedGate ? REVAMP_VOUCHER_BANNER_CONFIG : undefined
  })), /*#__PURE__*/React.createElement(Box, {
    className: `${s.hero} ${transition.header}`,
    direction: "vertical",
    align: "center",
    width: "100%",
    boxSizing: "border-box",
    borderRadius: "8px",
    backgroundColor: "#E6E2FF"
  }, /*#__PURE__*/React.createElement(Box, {
    className: s.heroSearch,
    direction: "vertical",
    align: "center",
    gap: "20px",
    width: "100%"
  }, /*#__PURE__*/React.createElement(SiteGateHeader, {
    className: s.heroHeader,
    gap: "20px",
    genericTitleForDefaultSiteName: true,
    titleKey: titleKey
  }), /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "12px",
    maxWidth: isRevampedGate ? '800px' : '700px',
    className: `${s.searchBarWrapper} ${transition.searchBar}`
  }, /*#__PURE__*/React.createElement(HeroSearchBar, {
    compact: isRevampedGate,
    iconOnly: iconOnlySearchButton,
    onSubmit: filters => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'search',
        value: filters.query || undefined
      });
      prefetchRecommendations();
      setTimeout(() => {
        const searchParams = getUrlState(filters);
        navigateTo(`/results?${searchParams}`);
      }, 500);
    }
  }), showTldChips && /*#__PURE__*/React.createElement(GateTldChips, null))), !isRevampedGate && /*#__PURE__*/React.createElement(PreSuggestionsOptimized, null))), /*#__PURE__*/React.createElement("main", {
    className: `${s.mainContent} ${transition.content}`,
    tabIndex: -1
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    className: s.content
  }, isRevampedGate ? /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%",
    marginBlock: "16px",
    gap: "16px"
  }, /*#__PURE__*/React.createElement(PreSuggestions, {
    showCardShadow: suggestionCardShadow
  }), /*#__PURE__*/React.createElement(SocialProofCard, null)) : null, /*#__PURE__*/React.createElement("div", {
    ref: tldGridRef
  }, /*#__PURE__*/React.createElement(TldPromotionBoxes, {
    voucherAwarePricing: isRevampedGate,
    tldPressFillsSearch: isRevampedGate
  })), /*#__PURE__*/React.createElement(MoreTools, null), /*#__PURE__*/React.createElement("div", {
    ref: faqRef
  }, /*#__PURE__*/React.createElement(FAQs, {
    onToggle: index => {
      DomainSearchSuiteModule.internals.bi.onCTAClick == null || DomainSearchSuiteModule.internals.bi.onCTAClick({
        ctaClick: 'asked_questions',
        value: JSON.stringify(index)
      });
    }
  })))));
};
//# sourceMappingURL=SiteLevelGateHomeOptimizedContent.js.map